import { Button, MenuItem, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'
import './EditRole.css'
import axiosApiInstance from '../axios';
import CAlertBox from '../CAlertBox/CAlertBox';


const EditRole = ({ onRoleChange, id,setIsAddRole,openAddMsg }) => {
  const [role, setRole] = useState([])
  const [roleId, setRoleId] = useState(0)
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    axiosApiInstance.get('/role')
      .then(req => setRole(req.data.data))
  }, [])

  const rolechange = (event) => {
    setRoleId(event.target.value)
  };


  const saveRole = () => {

    let data = JSON.stringify({
      "roleId": roleId,
      "employeeId": id

    });

    axiosApiInstance.post('/role', data).then(function (response) {
      

      console.log((response.data));
      if (response.data.succeeded == false){
        setAlertMessage(response.data.message);
      }
      else{
        setIsAddRole(true);
        onRoleChange();
        openAddMsg(true);

      }
    }).catch(function (error) {
      setAlertMessage(error);
    });
    
  }

  return (
    <>
      <div>

        <Select className='select-role'
          name="nextParty"
          value={roleId}
          onChange={rolechange}>
          <MenuItem value="0" disabled>Edit</MenuItem>
          {role.map((erole, index) => (
            <MenuItem key={index} value={erole.id}>{erole.name}</MenuItem>
          ))
          }
        </Select>

      </div>
      <Button className="role-save-btn" onClick={saveRole}>Save</Button>
      <Button className="role-cancel-btn" onClick={onRoleChange}>Cancel</Button>
      <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />
    </>
  )
}



export default EditRole